export default "__VITE_ASSET__e21994ab__"